import { Link } from 'react-router-dom';
import Button from '@/components/ui/Button';
import { HomeIcon } from '@heroicons/react/24/outline';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-24 h-24 mx-auto mb-6 rounded-3xl bg-gradient-to-br from-primary-400 to-primary-500 flex items-center justify-center shadow-lg">
          <span className="text-white text-5xl font-bold">K</span>
        </div>
        <h1 className="text-6xl font-bold text-slate-800 mb-4">404</h1>
        <p className="text-xl text-slate-600 mb-2">Page Not Found</p>
        <p className="text-slate-500 mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/dashboard">
          <Button size="lg" leftIcon={<HomeIcon className="w-5 h-5" />}>
            Back to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
}

